import React, { useEffect, useRef, useState } from "react";
import "./PNUDCarouselVideoCard.css";
import MISC_TEXT from "../../../utils/text/misc.json";
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";
import ReactPlayer from "react-player";

export default function PNUDCarouselVideoCard({
  id,
  title,
  description,
  videoFileName,
  disableFlip,
  currentSlide,
  normalPointer,
}) {
  const cardRef = useRef(null);
  const { language } = useCurrentLanguage();
  const [frontShowing, setFrontShowing] = useState(true);

  function flipCard() {
    if (disableFlip) return;

    if (frontShowing) {
      cardRef.current.className = "pnud-card-inner flip-card";
      setFrontShowing(false);
    } else {
      cardRef.current.className = "pnud-card-inner flip-card-back";
      setFrontShowing(true);
    }
  }

  useEffect(() => {
    cardRef.current.className = "pnud-card-inner flip-card-back";
    setFrontShowing(true);
  }, [currentSlide]);

  return (
    <div className="pnud-card-container">
      <button
        className={
          "pnud-button-container" + (normalPointer ? " normal-pointer" : "")
        }
        onClick={flipCard}
      >
        <div className="pnud-card">
          <div id={id} ref={cardRef} className="pnud-card-inner">
            <div className="pnud-card-front pnud-gold-border">
              <div>
                <h1 className="pnud-card-title">{title}</h1>
                <p className="pnud-card-description">{description}</p>
              </div>
              {!disableFlip ? (
                <span className="click-to-back">
                  {MISC_TEXT["clickToBack"][language]}
                </span>
              ) : null}
            </div>
            <div className="pnud-card-back">
              <div className="pnud-card-video-wrapper">
                <ReactPlayer
                  width={"100%"}
                  height={"90%"}
                  controls={true}
                  muted={true}
                  volume={0.8}
                  loop={false}
                  url={videoFileName}
                />
              </div>
            </div>
          </div>
        </div>
      </button>
    </div>
  );
}
